<template>
  <div class="nd-cell" :style="{ 'background-color': backgroundColor }">
    <div class="nd-cell-header" :class="{ 'has-content': content }" @click="$emit('click')">
      <div class="container">
        <img class="icon" v-if="icon" :src="icon"/>
        <span class="title" :class="{ 'has-icon': icon }" v-if="title || $slots.title">
          <slot name="title">{{ title }}</slot>
        </span>
      </div>

      <div class="container">
        <span class="text" :class="{ 'has-arrow': arrow }" v-if="text || $slots.text">
          <span v-html="text" v-if="type==='vhtml'"></span>
          <slot name="text" v-else>{{ text }}</slot>
        </span>
        <i class="arrow" v-show="arrow"/>
      </div>
    </div>
    <div class="nd-cell-content" v-if="content">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'nd-cell',

  description: '表单元素Cell - 按钮行',

  data () {
    return {

    }
  },

  props: {
    arrow: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: ''
    },
    type: String,
    title: {
      type: String,
      default: ''
    },
    content: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: '#FFFFFF'
    },
    text: {
      type: String,
      default: ''
    }
  },

  methods: {
    clickHandler (...arg) {
      this.$emit('click', ...arg)
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

    @keyframes bling {
      to { opacity: 0.3;}
    }
    .nd-cell {
        overflow: hidden;
        width: 100%;
        &.bling{ 
          position: relative;
          transition: 0.3s;
          &:after{
            content: "";
            position: absolute;
            width: 100%;
            height: 100%;
            pointer-events: none;
            top:0;
            animation: bling .5s linear infinite alternate;
            background: #f32a14;
            opacity: 0;
          }
        
        }
        .nd-cell-header {
            height: 110px;
            padding: 0 23px;
            width: 100%;
            display: flex;
            align-items: center;
            flex-direction: row;
            justify-content: space-between;
            

            .container {
                height: 100%;
                display: flex;
                align-items: center;
                flex-direction: row;
            }

            &.has-content {
                height: 100px;
                line-height: 100px;
            }

            .icon {
                width: 60px;
                height: 60px;
            }

            .title {
                font-size: 30px;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
                color: @fc1;

                &.has-icon {
                    padding-left: 15px;
                }
            }

            .text {
                font-size: 30px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                &.has-arrow {
                    padding-right: 10px;
                }
            }

            .arrow {
                width: 9px;
                height: 16px;
                background-image: url(./images/arrow.png);
                background-size: cover;
            }
        }
    }
</style>